import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  PointsType, ProfileType, DataPurchaseType, ProductGroupType, PurchasesType,
} from '@src/types/user'

export const initialState = {
  points: {
    balanceInactive: 0,
    bonuses: 0,
    cardNumber: [],
  } as PointsType,
  profile: {
    surname: '',
    name: '',
    patronymic: '',
    birthday: '',
    phone: '',
    locality: '',
    email: '',
    cardNumber: [],
    isProcessingPersonalData: false,
    isLoyalty: false,
    isPromotionalMail: false,
    isPoll: false,
    isPromotionalGames: false,
    gender: '',
    getSms: false,
    isPollsConsent: false,
    lastBirthdayUpdate: '',
  } as ProfileType,
  successChangePhone: false,
  successChangeField: false,
  purchases: {
    content: [] as DataPurchaseType[],
    more: false,
  } as PurchasesType,
  electronicChips: 0 as any,
  productGroup: [] as ProductGroupType[],
  successChangePassword: false,
  isDeleteProfileStatus: false,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setPoints(state, { payload }: PayloadAction<PointsType>) {
      state.points = payload
    },
    setPurchases(state, { payload }) {
      state.purchases.content.push(...payload.content)
      state.purchases.more = payload.more
    },
    resetPurchases(state) {
      state.purchases.content = []
      state.purchases.more = false
    },
    setElectronicChips(state, { payload }) {
      state.electronicChips = payload
    },
    setProductGroup(state, { payload }) {
      state.productGroup = payload
    },
    setSuccessChangePassword(state, { payload }) {
      state.successChangePassword = payload
    },
    setProfile(state, { payload }) {
      state.profile = payload
    },
    setFieldValue(state, { payload }) {
      // @ts-ignore
      state.profile[payload.name] = payload.value
    },
    setIsSuccessChangePhone(state, { payload }: PayloadAction<boolean>) {
      state.successChangePhone = payload
    },
    successFieldChange(state, { payload }: PayloadAction<boolean>) {
      state.successChangeField = payload
    },
    deleteProfileStatus(state, { payload }: PayloadAction<boolean>) {
      state.isDeleteProfileStatus = payload
    },
    setResetField(state) {
      state.purchases.content = []
      state.purchases.more = false
    },
  },
})

export type UserStateType = typeof initialState

export const {
  setPoints,
  setProfile,
  setFieldValue,
  successFieldChange,
  setIsSuccessChangePhone,
  setPurchases,
  setElectronicChips,
  setProductGroup,
  setSuccessChangePassword,
  setResetField,
  resetPurchases,
  deleteProfileStatus,
} = userSlice.actions
export const userReducer = userSlice.reducer
